import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const transportTypeLocaleModule: LocaleModule = {
  name: "transportType",
  messages: { en: en, it: it },
};
